import PropTypes from "prop-types";

import EventDatasetName from "routes/meta_datasets/swoogo_events/EventDatasetName";
import useSwoogoEventDatasets from "routes/meta_datasets/swoogo_events/useSwoogoEventDatasets";

const EventDatasetValue = ({ eventId }) => {
  const { links } = useSwoogoEventDatasets([eventId]);
  const link = links.get(eventId);
  return link ? <EventDatasetName link={link} /> : "—";
};

EventDatasetValue.propTypes = {
  eventId: PropTypes.number.isRequired,
};

export default EventDatasetValue;
